import { render } from "./Pdf.vue?vue&type=template&id=a968c39c&scoped=true"
import script from "./Pdf.vue?vue&type=script&lang=js"
export * from "./Pdf.vue?vue&type=script&lang=js"

import "./Pdf.vue?vue&type=style&index=0&id=a968c39c&lang=scss&scoped=true"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a968c39c"]])

export default __exports__